import { isAppLanguage, resolveAppLanguage } from '@caro/shared/utils';
import type { Language } from './types';

/**
 * De taal van de app voor deze user (specs/20261016-taal-bewonersapp, T010, FR-1/FR-2).
 *
 *   user.appLanguage          (profiel/toestel: de keten zoals de server hem berekende)
 *   → user.person.appLanguage (login-sessie: de taal staat op `person`)
 *   → person.data.gameLanguage
 *   → user.siteLanguage / user.person.siteLanguage
 *   → 'nl'
 *
 * Puur, zonder React of store, zodat ook de splash en code buiten React hem kunnen gebruiken.
 */
export function resolveUserLanguage(user: any): Language {
  if (!user || typeof user !== 'object') return resolveAppLanguage();
  if (isAppLanguage(user.appLanguage)) return user.appLanguage;
  const person = user.person;
  if (person && isAppLanguage(person.appLanguage)) return person.appLanguage;

  // person.data kan een object of een JSON-string zijn.
  let data = person?.data;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      data = null;
    }
  }
  const siteLanguage = user.siteLanguage ?? person?.siteLanguage;
  return resolveAppLanguage(data?.gameLanguage, siteLanguage);
}

/** Taal uit de bewaarde sessie (`localStorage['caro_auth'].user`), anders 'nl'. */
export function storedSessionLanguage(): Language {
  try {
    const raw = localStorage.getItem('caro_auth');
    if (!raw) return resolveAppLanguage();
    return resolveUserLanguage(JSON.parse(raw)?.user);
  } catch {
    return resolveAppLanguage();
  }
}
